import { gql } from '@apollo/client';

export const GET_STREAM_BY_ID = gql`
  query GetStreamById($id: ID!) {
    getStreamById(id: $id) {
      mode
      rtmpIngestURL
      rtmpIngestKey
    }
  }
`;
